function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

export default function() {
  return this.each(lower);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/lower.js
// module id = ./node_modules/d3-selection/src/selection/lower.js
// module chunks = vendor